import { init } from '@rematch/core'
import { storyModels } from './stories'
import createRematchPersist from '@rematch/persist'
import createLoadingPlugin from '@rematch/loading'
import versionManager from './versionManager'

const persistPlugin = createRematchPersist({
  throttle: 50,
  version: 1
});

const store = init({
  models: {
    ...storyModels,
    versionManager
  },
  plugins: [persistPlugin, createLoadingPlugin()]
});

export default store